import { mergeData } from 'vue-functional-data-merge';

export default function styleHOCFactory (name = '', propOpts = []) {
  return {
    functional: true,
    props: {
      ...propOpts.reduce((obj, k) => ({
        ...obj,
        [k]: Boolean,
      }), {}),
      inactive: Boolean,
    },
    render (h, ctx) {
      const { $style, parent, data = {}, children, props } = ctx;
      const vNode = children[0];
      const scopeId = parent.$options._scopeId; // NOTE pass scopeId : https://github.com/vuejs/vue-loader/issues/559#issuecomment-271479195
      const styleClass = `_${name}-style`;
      const propsClass = propOpts.map(prop => props[prop] ? `-${prop}` : '').join(' ');
      const hashedClass = Object.values($style).join(' ');
      vNode.data = mergeData(vNode.data || {}, {
        ...data,
        staticClass: `${styleClass} ${props.inactive ? '' : hashedClass} ${propsClass}`,
      });
      vNode._scopeId = scopeId;
      return vNode;
    },
  };
}
